import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGemsProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGems: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGemsProps
> = props => {
  let component = props.component,
    range = props.range || {},
    name = component.name,
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="Gemfile" />
        <ArtifactViewCodeDiffDisplay type="normal" text="source 'https://rubygems.org'" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={'gem \u0027' + name + '\u0027, \u0027' + unsafeVersion + '\u0027'}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'gem \u0027' + name + '\u0027, \u0027' + safeVersion + '\u0027'}
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="Gemfile" />
        <ArtifactViewCodeDiffDisplay type="add" text="source 'https://rubygems.org'" />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={'gem \u0027' + name + '\u0027, \u0027' + safeVersion + '\u0027'}
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerRubyGems;
